

































import { defineComponent, onMounted, ref, useFetch, useRoute, computed, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { getProductTopicBgColor } from '~/utils/solepro/products';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';

export default defineComponent({
    components: {
        HTMLContent
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    setup(props) {
        const route = useRoute();
        const isPreviewPage = computed(() => route.value.query.preview == 'true'/* && customerStore.user?.hasPreview*/)
        const { isDev, $vsf } = useContext();
        const cmsUrl = $vsf.$magento.config.externalCheckout.cmsUrl

        const bgColor = ref('#F7F7F7');
        useFetch(async () => {
            const categoriesStore = useCategoryStore();
            await categoriesStore.load()
            const categories = categoriesStore.rawCategories?.items[0].children
            bgColor.value = getProductTopicBgColor(categories, props.product, '#F7F7F7')
        })

        onMounted(() => {
            setTimeout(() => {
                const points = Array.from(document.querySelectorAll('.area_funzionalita .pb_column-group .pagebuilder-column:first-child'))
                if (points.length < 1) return;
                points.forEach(el => el.classList.add('basis-0'))
            }, 0)
        })

        const areaFunzionalitaChildrenFilter = (el) => isPreviewPage.value ? el.showInPreview : el.showOnline;

        /** Used only here, synchronously, to compute the layout flags below.
         * Never stored in a ref / returned from setup: this component uses useFetch(),
         * and Nuxt serializes reactive component state for hydration, which would
         * turn the DOM nodes held in this tree's DOMContent into empty objects. */
        let hasMainComponentsInFunzionalita = false;
        let isAreaFunzionalitaFull = false;
        let isAreaFunzionalitaColumns = false;
        if (props.product.area_funzionalita) {
            const parsed = getAsJSON(props.product.area_funzionalita, false, isDev, false, cmsUrl);
            const visibleChildren = (parsed.children || []).filter(areaFunzionalitaChildrenFilter);
            hasMainComponentsInFunzionalita = visibleChildren.some(c => c.cssClasses?.includes('product-area-main'));
            isAreaFunzionalitaFull = visibleChildren.some(c => c.cssClasses?.includes('punti-forza-grid')) || hasMainComponentsInFunzionalita;
            isAreaFunzionalitaColumns = visibleChildren.some(c => c.cssClasses?.includes('punti-forza-columns'));
        }

        return {
            bgColor,
            areaFunzionalitaChildrenFilter,
            isAreaFunzionalitaColumns,
            isAreaFunzionalitaFull,
            hasMainComponentsInFunzionalita,
        }
    }
})
